import {authReducer} from './auth';
import { iLearnReducer } from './ilearn';
import { uiReducer } from "./ui";

import {combineReducers} from 'redux';

export const rootReducer = combineReducers({
  auth: authReducer,
  ilearn: iLearnReducer,
  ui: uiReducer,
});
